export default () => ({
  header: {
    marginTop: '50px',
  },
  table: {
    display: 'grid',
    grid: '50px / 200px 400px',
  },
  button: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});
